// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12Wn9","col":"styles_col__3TFEp"};